import React from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router';
// import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroller';

// import { APP_ROOT_URL } from '../../../actions/urlTypes';

const AccountListTable = ({
  accounts,
  pageStart,
  loadMore,
  hasMore,
  onSort,
  sortOrder,
  showAccountDetails,
}) => {
  const sortOrderVal = sortOrder === 'asc' ? 'desc' : 'asc';
  return (
    <div className="table-wrapper">
      <div className="table-head">
        <table>
          <thead>
            <tr className="table-row table-row-head">
              <th className="table-cell table-cell-name" style={{ width: '70%' }}>
                <button
                  className={`buttonSort text-left buttonSort_${sortOrder}`}
                  onClick={() => onSort('accountName', sortOrderVal)}
                >
                  Account Name
                </button>
              </th>
            </tr>
          </thead>
        </table>
      </div>

      <div className="table-body">
        <InfiniteScroll
          pageStart={pageStart}
          loadMore={loadMore}
          hasMore={hasMore}
          useWindow={false}
          threshold={5}
          loader={<div className="table-loader" key={0}>Loading ...</div>}
        >
          <table>
            <tbody>
              {
                accounts.map((account, i) => {
                  return (
                    <tr key={`${account.accountId}_${i}`} className="table-row table-row-body">
                      <td className="table-cell table-cell-name" style={{ width: '70%' }}>
                        <button onClick={() => showAccountDetails(account)} className="table-cell-button">
                          <span className="col-text">{account.accountName}</span>
                        </button>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </div>
  );
};


AccountListTable.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.object),
  pageStart: PropTypes.number,
  loadMore: PropTypes.func,
  showAccountDetails: PropTypes.func,
  onSort: PropTypes.func,
  hasMore: PropTypes.bool,
  sortOrder: PropTypes.string,
};

export default AccountListTable;
